// client/src/components/EmptyState.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

// Consistent "nothing here yet" panel: icon + message + optional call to action.
const EmptyState = ({ icon, title, description, actionLabel, actionTo, onAction, action }) => {
  return (
    <Box sx={{ textAlign: 'center', py: 6, px: 2 }}>
      {icon && (
        <Box sx={{ width: 72, height: 72, mx: 'auto', mb: 2, display: 'grid', placeItems: 'center', color: 'text.secondary', bgcolor: 'action.hover', '& svg': { fontSize: 34 } }}>
          {icon}
        </Box>
      )}
      <Typography variant="subtitle1" fontWeight={700} gutterBottom>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: actionLabel || action ? 2.5 : 0, maxWidth: 360, mx: 'auto' }}>
          {description}
        </Typography>
      )}
      {action}
      {!action && actionLabel && (
        actionTo ? (
          <Button variant="contained" component={Link} to={actionTo}>{actionLabel}</Button>
        ) : (
          <Button variant="contained" onClick={onAction}>{actionLabel}</Button>
        )
      )}
    </Box>
  );
};

export default EmptyState;
